module.exports = __webpack_public_path__ + "img/multiRed.1c429942.jpg";